import { useDatasourceLoader, LoadOutcome } from "./useDatasourceLoader";
import { useUserSettings } from "../context/UserSettingsContext";
import { clearContractingReportTable } from "../../excel/datasources/reportTables";
import { clearContractingDataTables } from "../../excel/reports/dataTables";
import { clearContractingCaches } from "../../api/bids";

export function useContractingLoader() {
  const { loadDatasources } = useDatasourceLoader();
  const { settings } = useUserSettings();

  const loadContracting = (): Promise<LoadOutcome> => loadDatasources([{ type: "contracting" }]);

  /** Drops contracting data from the workbook, leaving sheets and headers so formulas read blank. */
  const clearContracting = async (): Promise<void> => {
    await clearContractingReportTable();
    if (settings.hasDataSheets) await clearContractingDataTables();
    clearContractingCaches();
  };

  return { loadContracting, clearContracting };
}
